import angular from 'angular';

import ExtensionsComponent from './extensions.component';

const ExtensionsModule = angular
    .module('control-room.commons.content.component.extensions', [])
    .component('crExtensions', ExtensionsComponent);

export default ExtensionsModule;
